'use strict';
angular.module('app').factory('dealrTabSync', ['$window', '$cookies', '$timeout', '$injector', function ($window, $cookies, $timeout, $injector) {
  var KEY_PREFIX = 'dealr.session.';
  var KEY_ACTIVITY = KEY_PREFIX + 'activity';
  var KEY_AUTH_OK = KEY_PREFIX + 'authOk';
  var KEY_LOGIN = KEY_PREFIX + 'login';
  var KEY_ENDED = KEY_PREFIX + 'ended';
  var COOKIE_LOGIN_ANNOUNCE = 'login_announce';
  var AUTH_CHECK_MIN_INTERVAL = 110 * 1000;
  var ACTIVITY_TRUST_WINDOW = 5 * 60 * 1000;
  var ACTIVITY_WRITE_THROTTLE = 5 * 1000;
  var RECONCILE_THROTTLE = 500;
  var BROADCAST_MAX_AGE = 30 * 1000;
  var ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'touchmove', 'scroll'];
  var tabId = 'tab-' + Date.now().toString(36) + '-' + randomSuffix();
  var sessionStartedAt = Date.now();
  var memoryStore = {};
  var listening = false;
  var loginListeners = [];
  var endedListeners = [];
  var knownContextId = null;
  var lastActivityWrite = 0;
  var lastReconcileCheck = 0;
  var reconciledEndedTs = 0;
  var lastAuthCheckAttempt = 0;
  var confirmInFlight = false;
  var sessionEnded = false;
  var activityCallback = null;
  var service = {};
  var idCounter = 0;
  function randomSuffix() {
    try {
      var browserCrypto = $window.crypto || $window.msCrypto;
      if (browserCrypto && typeof browserCrypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(6);
        browserCrypto.getRandomValues(bytes);
        return Array.prototype.map.call(bytes, function (byte) {
          return ('0' + byte.toString(16)).slice(-2);
        }).join('');
      }
    } catch (e) {}
    idCounter++;
    return Date.now().toString(36) + idCounter.toString(36);
  }
  var storageUsable = true;
  function readRaw(key) {
    if (storageUsable) {
      try {
        return $window.localStorage.getItem(key);
      } catch (e) {
        storageUsable = false;
      }
    }
    return typeof memoryStore[key] === 'undefined' ? null : memoryStore[key];
  }
  function writeRaw(key, value) {
    if (storageUsable) {
      try {
        $window.localStorage.setItem(key, value);
        return;
      } catch (e) {
        storageUsable = false;
      }
    }
    memoryStore[key] = value;
  }
  function parseRecord(raw) {
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }
  function readRecord(key) {
    return parseRecord(readRaw(key));
  }
  function writeRecord(key, value) {
    writeRaw(key, JSON.stringify(value));
  }
  function removeRaw(key) {
    if (storageUsable) {
      try {
        $window.localStorage.removeItem(key);
        return;
      } catch (e) {
        storageUsable = false;
      }
    }
    delete memoryStore[key];
  }
  function ageOf(record) {
    return record && typeof record.ts === 'number' ? Date.now() - record.ts : Infinity;
  }
  function contextAuth() {
    try {
      if ($injector.has('authContext')) {
        return $injector.get('authContext').getContextAuthRecord().auth;
      }
    } catch (e) {}
    try {
      return $cookies.getObject('auth');
    } catch (e) {
      return null;
    }
  }
  function currentAuthToken() {
    var auth = contextAuth();
    return auth && auth.token ? auth.token : null;
  }
  function accessUserIdFromPath() {
    try {
      if ($injector.has('authContext')) {
        return $injector.get('authContext').getAccessUserIdFromPath();
      }
    } catch (e) {}
    return null;
  }
  function decodeToken(token) {
    if (!token) return null;
    try {
      if (typeof $window.jwt_decode === 'function') {
        return $window.jwt_decode(token);
      }
    } catch (e) {}
    try {
      var payload = token.split('.')[1];
      if (!payload) return null;
      var normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
      while (normalized.length % 4) {
        normalized += '=';
      }
      return JSON.parse($window.atob(normalized));
    } catch (e) {
      return null;
    }
  }
  function tokenIdOf(token) {
    var claims = decodeToken(token);
    return claims && claims.jti ? claims.jti : null;
  }
  service.currentTokenId = function () {
    return tokenIdOf(currentAuthToken());
  };
  service.currentUserId = function () {
    var claims = decodeToken(currentAuthToken());
    return claims && typeof claims.uid !== 'undefined' && claims.uid !== null ? String(claims.uid) : null;
  };
  service.currentContextId = function () {
    if (knownContextId) {
      return knownContextId;
    }
    var id = accessUserIdFromPath() || service.currentUserId();
    if (id) {
      knownContextId = id;
    }
    return id || knownContextId;
  };
  knownContextId = accessUserIdFromPath() || service.currentUserId();
  function activityKey() {
    var contextId = service.currentContextId();
    return contextId ? KEY_ACTIVITY + '.' + contextId : KEY_ACTIVITY;
  }
  function endedKeyFor(contextId) {
    return contextId ? KEY_ENDED + '.' + contextId : KEY_ENDED;
  }
  function endedKey() {
    return endedKeyFor(service.currentContextId());
  }
  service.noteActivity = function () {
    var ts = Date.now();
    if (ts - lastActivityWrite < ACTIVITY_WRITE_THROTTLE) return false;
    lastActivityWrite = ts;
    writeRecord(activityKey(), {
      ts: ts,
      tabId: tabId
    });
    return true;
  };
  service.activeWithin = function (windowMs) {
    return ageOf(readRecord(activityKey())) <= windowMs;
  };
  service.noteAuthHealthy = function () {
    writeRecord(KEY_AUTH_OK, {
      ts: Date.now(),
      tabId: tabId,
      tokenId: service.currentTokenId()
    });
  };
  service.shouldRunAuthCheck = function (minIntervalMs) {
    var interval = minIntervalMs || AUTH_CHECK_MIN_INTERVAL;
    if (Date.now() - lastAuthCheckAttempt < interval) return false;
    var record = readRecord(KEY_AUTH_OK);
    var due = !record || ageOf(record) > interval || record.tokenId !== service.currentTokenId();
    if (due) {
      lastAuthCheckAttempt = Date.now();
    }
    return due;
  };
  service.classifyUnauthorized = function (failedToken) {
    var cookieToken = currentAuthToken();
    if (!cookieToken) return 'ended';
    if (failedToken && cookieToken !== failedToken) return 'retry';
    var healthy = readRecord(KEY_AUTH_OK);
    if (healthy && ageOf(healthy) <= AUTH_CHECK_MIN_INTERVAL && healthy.tokenId === tokenIdOf(cookieToken)) {
      return 'confirm';
    }
    if (service.activeWithin(ACTIVITY_TRUST_WINDOW)) return 'confirm';
    return 'ended';
  };
  service.handleUnauthorized = function (failedToken, options) {
    var allowEndSession = !options || options.allowEndSession !== false;
    var verdict = service.classifyUnauthorized(failedToken);
    if (verdict === 'retry') return 'retry';
    if (verdict === 'confirm') {
      service.confirmSession(allowEndSession);
      return 'handled';
    }
    if (allowEndSession) {
      service.endSession('unauthorized');
    }
    return 'handled';
  };
  service.handleUnauthorizedFor = function (failedToken, interceptorConfig) {
    return service.handleUnauthorized(failedToken, {
      allowEndSession: !interceptorConfig || interceptorConfig.redirectOn401 !== false
    });
  };
  service.confirmSession = function (allowEndSession) {
    if (confirmInFlight || sessionEnded) return false;
    confirmInFlight = true;
    var mayEnd = allowEndSession !== false;
    $injector.get('$http')({
      method: 'POST',
      url: '/api/checkauth',
      data: {
        check: true
      },
      headers: {
        'no-redirect': 1
      }
    }).then(function () {
      confirmInFlight = false;
      service.noteAuthHealthy();
    }, function (response) {
      confirmInFlight = false;
      if (mayEnd && response && response.status === 401) {
        service.endSession('checkauth_failed');
      }
    });
    return true;
  };
  service.loginPathForCurrentPage = function () {
    return '/#/access/login?redirUrl=' + encodeURIComponent($window.location.href);
  };
  service.endSession = function (reason) {
    if (sessionEnded) return;
    sessionEnded = true;
    var userId = service.currentContextId();
    if ($window.Intercom) {
      try {
        $window.Intercom('shutdown');
      } catch (e) {}
    }
    try {
      $cookies.remove('auth', {
        path: '/'
      });
    } catch (e) {}
    try {
      $cookies.remove('auth');
    } catch (e) {}
    try {
      $window.sessionStorage.removeItem('dealr.agreementPopupsShown');
    } catch (e) {}
    writeRecord(endedKey(), {
      ts: Date.now(),
      tabId: tabId,
      reason: reason,
      userId: userId
    });
    $window.location.href = service.loginPathForCurrentPage();
  };
  service.announceLogin = function (payload) {
    var userId = payload && payload.userId ? String(payload.userId) : null;
    removeRaw(userId ? endedKeyFor(userId) : endedKey());
    writeRecord(KEY_LOGIN, {
      ts: Date.now(),
      tabId: tabId,
      userId: userId,
      type: payload && payload.type ? payload.type : null
    });
  };
  function consumeServerLoginSignal(contextId) {
    var signal = null;
    try {
      signal = $cookies.get(COOKIE_LOGIN_ANNOUNCE);
    } catch (e) {
      return false;
    }
    if (!signal) return false;
    if (String(signal) !== String(contextId)) return false;
    try {
      $cookies.remove(COOKIE_LOGIN_ANNOUNCE, {
        path: '/'
      });
    } catch (e) {}
    try {
      $cookies.remove(COOKIE_LOGIN_ANNOUNCE);
    } catch (e) {}
    return true;
  }
  function announceServerSideLogin() {
    var auth = contextAuth();
    if (!auth || !auth.token) return;
    var contextId = service.currentContextId();
    if (!contextId) return;
    if (!consumeServerLoginSignal(contextId)) return;
    service.announceLogin({
      userId: contextId,
      type: auth.type
    });
  }
  service.onLoginElsewhere = function (callback) {
    loginListeners.push(callback);
    startListening();
  };
  service.onSessionEndedElsewhere = function (callback) {
    endedListeners.push(callback);
    startListening();
  };
  function notify(listeners, record) {
    $timeout(function () {
      for (var i = 0; i < listeners.length; i++) {
        try {
          listeners[i](record);
        } catch (e) {}
      }
    });
  }
  function handleStorageEvent(event) {
    if (!event || !event.key) return;
    if (event.key !== KEY_LOGIN && event.key.indexOf(KEY_ENDED) !== 0) return;
    var record = parseRecord(event.newValue) || readRecord(event.key);
    if (!record || record.tabId === tabId) return;
    if (ageOf(record) > BROADCAST_MAX_AGE) return;
    if (event.key === KEY_LOGIN) {
      notify(loginListeners, record);
      return;
    }
    if (event.key !== endedKey()) return;
    if (!readRecord(event.key)) return;
    if (endedRecordSuperseded(record, service.currentContextId())) return;
    notify(endedListeners, record);
  }
  function endedRecordSuperseded(record, contextId) {
    var login = readRecord(KEY_LOGIN);
    return !!(login && typeof login.ts === 'number' && login.ts > record.ts && (!login.userId || !contextId || login.userId === contextId));
  }
  function startListening() {
    if (listening) return;
    listening = true;
    $window.addEventListener('storage', handleStorageEvent, false);
  }
  service.reconcileEndedSession = function () {
    if (sessionEnded) return false;
    var record = readRecord(endedKey());
    if (!record || typeof record.ts !== 'number') return false;
    if (record.tabId === tabId) return false;
    if (record.ts <= sessionStartedAt) return false;
    var userId = service.currentContextId();
    if (record.userId && userId && record.userId !== userId) return false;
    if (endedRecordSuperseded(record, userId)) return false;
    if (record.ts <= reconciledEndedTs) return false;
    if (!service.confirmSession(true)) return false;
    reconciledEndedTs = record.ts;
    return true;
  };
  function reconcileThrottled(force) {
    var now = Date.now();
    if (!force && now - lastReconcileCheck < RECONCILE_THROTTLE) return false;
    lastReconcileCheck = now;
    return service.reconcileEndedSession();
  }
  function handleActivity(force) {
    if (reconcileThrottled(force)) return;
    var recorded = service.noteActivity();
    if (!recorded && !force) return;
    if (!activityCallback) return;
    try {
      activityCallback();
    } catch (e) {}
  }
  service.start = function (options) {
    activityCallback = options && options.onActivity ? options.onActivity : null;
    startListening();
    for (var i = 0; i < ACTIVITY_EVENTS.length; i++) {
      $window.document.addEventListener(ACTIVITY_EVENTS[i], function () {
        handleActivity(false);
      }, {
        passive: true,
        capture: true
      });
    }
    $window.document.addEventListener('visibilitychange', function () {
      if ($window.document.visibilityState === 'visible') {
        handleActivity(true);
      }
    }, false);
    service.noteActivity();
    announceServerSideLogin();
  };
  service.AUTH_CHECK_MIN_INTERVAL = AUTH_CHECK_MIN_INTERVAL;
  service.ACTIVITY_TRUST_WINDOW = ACTIVITY_TRUST_WINDOW;
  return service;
}]);